import { SVGProps } from "react"

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="m20.614 11.5.016-.816L1.545.81.247 1.8l.917 7.94 15.574 1.76-15.574 1.759-.917 7.94 1.298.99 19.085-9.874-.016-.816Z" />
    </svg>
)

export default SvgComponent
